import { ConfigService } from '../../services/config.service'

const state = {
    messsages: []
}

// getters
const getters = {
}
// actions
const actions = {
    GetNavMessages({ commit }) {
        return new Promise((resolve, reject) => {
            ConfigService.GetNavMessages(
                apiData => {
                    commit('setNavMessages',
                        {
                            apiData: apiData,
                        }),
                        resolve()
                },
                err => {
                    reject(err)
                }
            )
        })
    },
}

// mutations
const mutations = {
    setNavMessages(state, { apiData } ) {
        state.messsages = apiData;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}